import subIssueTypesServices from "../../services/api/SubIssueTypes";
import issueTypesService from "../../services/api/IssueTypes";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import ErrorMsgs from "../../constants/Errors.json";
import SuccessMessages from "../../constants/SucessMessages.json";
import { isValNull } from "../../utils";

function handleError(err) {
  console.log("error in sub issue types actions:", err);
}

export const setSubIssueTypeList = (payload) => {
  return {
    type: ActionTypes.SET_SUB_ISSUE_TYPE_LIST,
    payload,
  };
};
export const setSubIssueTypeDetails = (payload) => {
  return {
    type: ActionTypes.SET_SUB_ISSUE_TYPE_DETAILS,
    payload,
  };
};
export const setIssueTypeListRemoteSearch = (payload) => {
  return {
    type: ActionTypes.SET_ISSUE_TYPE_LIST_REMOTE_SEARCH,
    payload,
  };
};

export const setSubIssueTypeActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_SUB_ISSUE_TYPE_ACTIVE_FILTERS,
    payload,
  };
};
export const setActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_SUB_ISSUE_TYPE_ACTIVE_FILTERS,
    payload,
  };
};
export const setCurrentPageSubIssueType = (payload) => {
  return {
    type: ActionTypes.SET_CURRENT_PAGE_SUB_ISSUE_TYPE,
    payload,
  };
};
export const setSubIssueTypesListRemoteSearch = (payload) => {
  return {
    type: ActionTypes.SET_SUB_ISSUE_TYPE_LIST_REMOTE_SEARCH,
    payload,
  };
};

export const getSubIssueTypesList =
  (pageNumber, activeFilters) => async (dispatch) => {
    try {
      const filterKeys = {
        issueType: "issueType",
        issueTypeId: "parentId",
        name: "name",
        externalMappingName: "externalMappingName",
        enabled: "enabled",
        issueArea: "issueArea",
        zendeskArticleId: "zendeskArticleId",
      };
      let filterBody = {};
      let activeFiltersObj = {};
      Object.keys(activeFilters).map((key, index) => {
        if (!isValNull(activeFilters[key])) {
          Object.assign(activeFiltersObj, { [key]: activeFilters[key] });
          if (key === "enabled") {
            Object.assign(filterBody, {
              [filterKeys[key]]:
                activeFilters[key] === "Yes" ? "true" : "false",
            });
          } else if (key !== "issueType") {
            Object.assign(filterBody, {
              [filterKeys[key]]: activeFilters[key],
            });
          }
        }
      });
      const body = {
        filters: filterBody,
        pageRequest: {
          page: pageNumber,
          pageSize: 20,
        },
      };
      // console.log(body);
      dispatch(setLoader(true));
      const response = await subIssueTypesServices.getSubIssueTypesList(body);
      dispatch(setLoader(false));
      if (response) {
        dispatch(setSubIssueTypeList(response));
        dispatch(setActiveFilters(activeFiltersObj));
        dispatch(setCurrentPageSubIssueType(pageNumber));
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };
export const getSubIssueTypesDetails = (subIssueId) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    const response = await subIssueTypesServices.getSubIssueTypesDetails(
      subIssueId
    );
    dispatch(setLoader(false));
    if (response) {
      dispatch(setSubIssueTypeDetails(response));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const saveUpdateSubIssueTypes =
  (actionType, body) => async (dispatch) => {
    try {
      dispatch(setLoader(true));
      const response = await subIssueTypesServices.saveUpdateSubIssueTypes(
        actionType,
        body
      );
      dispatch(setLoader(false));
      if (response) {
        dispatch(
          setStatus({
            type: "success",
            message:
              actionType === "create"
                ? SuccessMessages.CREATION_SUCCESS
                : SuccessMessages.UPDATION_SUCCESS,
          })
        );
        dispatch(setSubIssueTypeDetails(body));
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getIssueTypeRemoteSearch = (startsWith) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    if (Object.keys(startsWith).length === 0) {
      startsWith.startswith = "";
    }
    const response = await issueTypesService.getIssueTypeRemoteSearch(
      startsWith.startswith
    );
    dispatch(setLoader(false));
    if (response) {
      dispatch(setIssueTypeListRemoteSearch(response));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getSubIssueTypeRemoteSearch =
  (startsWith, pageReq) => async (dispatch) => {
    try {
      dispatch(setLoader(true));
      if (Object.keys(startsWith).length === 0) {
        startsWith.startswith = "";
      }
      const response =
        await subIssueTypesServices.getSubIssueTypesListRemoteSearch(
          startsWith.startswith,
          pageReq.page ? pageReq.page : 1
        );
      dispatch(setLoader(false));
      if (response) {
        dispatch(setSubIssueTypesListRemoteSearch(response));
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };
